import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { InsideLookSection } from '../components/InsideLookSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
import { useScreenInit } from '../useScreenInit';
export function LandingPage() {
  useScreenInit();
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-274" data-mp="2zjymru2xailg">
      <HeroSection data-id="element-275" data-mp="33k8xtl5knz76" />
      <ProofSection data-id="element-276" data-mp="33lk4bsqejl1z" />
      <ProblemSection data-id="element-277" data-mp="33l1xy3a0zqgc" />
      <SystemSection data-id="element-278" data-mp="33ifp80bef4wj" />
      <ModulesSection data-id="element-279" data-mp="38jvey5oitzl9" />
      <InsideLookSection data-id="element-280" data-mp="38jd689ko9swg" />
      <BonusSection data-id="element-281" data-mp="38i27io633bc7" />
      <UrgencySection data-id="element-282" data-mp="38hipl7gfomy6" />
      <PricingSection data-id="element-283" data-mp="3da20txrnf5zt" />
      <TestimonialsSection data-id="element-284" data-mp="3dallvncliai2" />
      <GuaranteeSection data-id="element-285" data-mp="3dbwp9m24pg8n" />
      <FAQSection data-id="element-286" data-mp="3dc6fnar35pev" />
      <FinalCTA data-id="element-287" data-mp="3i9on0wpgfwkr" />
      <Footer data-id="element-288" data-mp="3ia7u1idkh0k0" />
      <PurchasePopup data-id="element-289" data-mp="3i8n09uz2tln7" />
    </main>;
}